const isCloseToExpire = (
  expiresAt: string | null,
  publishedDate: string | null,
  toExpireInDays: number = 90,
  thresholdDays: number = 7,
): boolean => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let expiryDate: Date;

    if (expiresAt) {
      expiryDate = new Date(expiresAt);
    } else if (publishedDate) {
      expiryDate = new Date(publishedDate);
      expiryDate.setDate(expiryDate.getDate() + toExpireInDays);
    } else {
      return false;
    }

    expiryDate.setHours(0, 0, 0, 0);

    const remainingDays = Math.ceil(
      (expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
    );

    return remainingDays >= 0 && remainingDays <= thresholdDays;
  } catch (error) {
    console.error('Error parsing date:', error);
    return false;
  }
};

const isExpired = (expiryDate: string | null | undefined): boolean => {
  if (!expiryDate) return false;

  try {
    const expiry = new Date(expiryDate);
    const today = new Date();

    // Reset time portions for accurate day comparison
    today.setHours(0, 0, 0, 0);
    expiry.setHours(0, 0, 0, 0);

    // Return true if expiry date is before today
    return expiry.getTime() < today.getTime();
  } catch (error) {
    console.error('Error parsing date:', error);
    return false;
  }
};

const isWithinDaysOfExpiry = (
  expiryDate: string | null,
  thresholdDays: number = 7,
): boolean => {
  if (!expiryDate) return false;

  try {
    const expiry = new Date(expiryDate);
    const now = new Date();

    // Reset time to start of day for accurate comparison
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expiryDay = new Date(
      expiry.getFullYear(),
      expiry.getMonth(),
      expiry.getDate(),
    );

    // Calculate remaining days
    const remainingDays = Math.ceil(
      (expiryDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
    );

    // Return true if within threshold (and not expired)
    return remainingDays <= thresholdDays && remainingDays >= 0;
  } catch (error) {
    console.error('Error parsing date:', error);
    return false;
  }
};

export {isCloseToExpire, isExpired, isWithinDaysOfExpiry};
